function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Icon/Big/OneDrop"
}, React.createElement("path", {
  id: "Fill 1",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M35.2979 2.58478C31.1928 6.52314 8.88652 28.5343 8.88652 41.7613C8.88652 56.2948 20.7348 68.1174 35.2979 68.1174C49.8609 68.1174 61.7092 56.2948 61.7092 41.7613C61.7092 28.5343 39.403 6.52314 35.2979 2.58478ZM35.2979 70C19.6944 70 7 57.3321 7 41.7613C7 26.4512 33.5264 1.64538 34.6555 0.596778L35.2979 0L35.9402 0.596778C37.0693 1.64538 63.5957 26.4512 63.5957 41.7613C63.5957 57.3321 50.9013 70 35.2979 70Z",
  fill: "#6E6E6E"
}));

var SvgOneDrop = function SvgOneDrop(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgOneDrop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/one-drop.d8ec6ecd.svg";
export { ForwardRef as ReactComponent };